import { GlFormCheckbox } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import SafeHtml from '~/vue_shared/directives/safe_html';
export default {
    name: 'MultipleChoiceSelectorItem',
    components: {
        GlFormCheckbox
    },
    directives: {
        SafeHtml
    },
    props: {
        value: {
            type: String,
            required: false,
            default: null
        },
        title: {
            type: String,
            required: false,
            default: null
        },
        description: {
            type: String,
            required: false,
            default: null
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        disabledMessage: {
            type: String,
            required: false,
            default: null
        }
    }
};
